import { gql } from "@apollo/client";

export const ADMIN_BLOGS_QUERY = gql`
  query AdminBlogs {
    blogs(admin: true) {
      id
      title
      slug
      excerpt
      coverImage
      status
      publishedAt
      content
      createdAt
    }
  }
`;

export const ADMIN_UPSERT_BLOG_MUTATION = gql`
  mutation AdminUpsertBlog(
    $id: ID
    $title: String!
    $excerpt: String
    $content: String!
    $coverImage: String
    $status: BlogStatusEnum!
    $publishedAt: ISO8601DateTime
  ) {
    adminUpsertBlog(
      input: {
        id: $id
        title: $title
        excerpt: $excerpt
        content: $content
        coverImage: $coverImage
        status: $status
        publishedAt: $publishedAt
      }
    ) {
      blog {
        id
        title
        slug
        excerpt
        coverImage
        status
        content
        publishedAt
        createdAt
      }
      errors
    }
  }
`;

export const ADMIN_DELETE_BLOG_MUTATION = gql`
  mutation AdminDeleteBlog($id: ID!) {
    adminDeleteBlog(input: { id: $id }) {
      success
      errors
    }
  }
`;
